import handleApi from "../../helpers/apiHelper";
import MaisAtacado from "./MaisAtacado";

const getFaturas = (forma) => handleApi(() => MaisAtacado.get(`/v1/negociacao/`, { params: { forma } }));
const setNegociacao = (params) => handleApi(() => MaisAtacado.post(`/v1/negociacao/proposta`, params));

const Negociacao = { getFaturas, setNegociacao };
export default Negociacao;
